import { alpha } from "@mui/material";
import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  toolbarminiWrapper: {
    zIndex: 100,
    gap: 0.5,
    flexDirection: "row",
    alignItems: "center",
  },
};

export const commonStyles = (isActive: boolean) => ({
  borderRadius: 2,
  zIndex: 100,
  backgroundColor: isActive ? "royalblue" : alpha("#ffffff", 0.05),
  backdropFilter: 'blur(10px)',
  border: `1px solid ${alpha("#ffffff", 0.12)}`,
  cursor: "pointer",
  minWidth: "1.8rem",
  width: "2.2rem",
  aspectRatio: "1 / 1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:hover": {
    backgroundColor: isActive ? "royalblue" : "background.paper",
  },
});
